module.exports = __webpack_public_path__ + "img/bepreisung_3.486ceb12.png";